module.exports = __webpack_public_path__ + "img/SCHEME_DESKTOP_EN.769bbef4.svg";